import { cameraApiRequest } from './cameraApiRequest';

/**
 * Marks a clip to keep (the retention job leaves it) or not: `{ keep }`.
 * Answers `{ clip }`.
 */
export const patchCameraClip = ({
  projectId,
  cameraId,
  clipId,
  keep,
  activeEmployerInfo,
}) =>
  cameraApiRequest({
    method: 'PATCH',
    apiPath: `projects/${projectId}/cameras/${cameraId}/clips/${clipId}`,
    body: { keep },
    activeEmployerInfo,
  });
